// src/sections/AboutUs.js
import React from 'react';
import './AboutUs.css';

export default function AboutUs() {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <h2>About Us</h2>
        <p>
          SK Logistics Group is a leading provider of integrated supply chain and logistics solutions across India.
          With over <strong>400,000 sq. ft.</strong> of warehousing space and a fleet of temperature-controlled vehicles,
          we specialize in end-to-end logistics for pharmaceuticals, cosmetics, and FMCG sectors.
        </p>
        <p>
          Certified by <strong>ISO 9001:2015</strong> and compliant with <strong>WHO-GDP</strong> and <strong>GMP</strong> standards,
          we ensure safety, efficiency, and transparency in every operation. From warehousing to distribution, we are your trusted logistics partner.
        </p>
      </div>
    </section>
  );
}
